import { ComponentType } from '@interfaces/component-type';
import styled, { Theme } from '@src/styled-components';
import { Button, Col, Modal } from 'antd';
import React from 'react';

import CalculatorTaskComponent from './ComponentsModal/Body/Content/TaskComponents/CalculatorTaskComponent';
import ConfirmTaskComponent from './ComponentsModal/Body/Content/TaskComponents/ConfirmTaskComponent';
import DateTaskComponent from './ComponentsModal/Body/Content/TaskComponents/DateTaskComponent';
import DrawTaskComponent from './ComponentsModal/Body/Content/TaskComponents/DrawTaskComponent';
import GoToTaskComponent from './ComponentsModal/Body/Content/TaskComponents/GoTotaskComponent';
import GPSTaskComponent from './ComponentsModal/Body/Content/TaskComponents/GPSTaskComponent';
import MatrixTaskComponent from './ComponentsModal/Body/Content/TaskComponents/MatrixTaskComponent';
import ModelTaskComponent from './ComponentsModal/Body/Content/TaskComponents/ModelTaskComponent';
import NumberTaskComponent from './ComponentsModal/Body/Content/TaskComponents/NumberTaskComponent';
import PhotoTaskComponent from './ComponentsModal/Body/Content/TaskComponents/PhotoTaskComponent';
import QRCodeTaskComponent from './ComponentsModal/Body/Content/TaskComponents/QRCodeTaskComponent';
import SampleImageTaskComponent from './ComponentsModal/Body/Content/TaskComponents/SampleImageTaskComponent';
import SampleTaskComponent from './ComponentsModal/Body/Content/TaskComponents/SampleTaskComponent';
import SampleTextTaskComponent from './ComponentsModal/Body/Content/TaskComponents/SampleTextTaskComponent';
import SampleVideoTaskComponent from './ComponentsModal/Body/Content/TaskComponents/SampleVideoTaskComponent';
import ScoreTaskComponent from './ComponentsModal/Body/Content/TaskComponents/ScoreTaskComponent';
import SelectTaskComponent from './ComponentsModal/Body/Content/TaskComponents/SelectTaskComponent';
import SelectTreeViewComponent from './ComponentsModal/Body/Content/TaskComponents/SelectTreeViewComponent';
import TextTaskComponent from './ComponentsModal/Body/Content/TaskComponents/TextTaskComponent';
import FormflowLateralMenu from './ComponentsModal/Body/LateralMenu/FormflowLateralMenu';
import IBaseComponent from './Interfaces/Base/IBaseComponent';
import ICalculatorComponent from './Interfaces/FormflowComponents/ICalculatorComponent';
import IConfirmComponent from './Interfaces/FormflowComponents/IConfirmComponent';
import IDateComponent from './Interfaces/FormflowComponents/IDateComponent';
import IDrawComponent from './Interfaces/FormflowComponents/IDrawComponent';
import IGotoComponent from './Interfaces/FormflowComponents/IGotoComponent';
import IGPSComponent from './Interfaces/FormflowComponents/IGPSComponent';
import IMatrixComponent from './Interfaces/FormflowComponents/IMatrixComponent';
import IModelComponent from './Interfaces/FormflowComponents/IModelComponent';
import INumberComponent from './Interfaces/FormflowComponents/INumberComponent';
import IPhotoComponent from './Interfaces/FormflowComponents/IPhotoComponent';
import ISampleComponent from './Interfaces/FormflowComponents/ISampleComponent';
import ISampleImageComponent from './Interfaces/FormflowComponents/ISampleImageTaskComponent';
import ISampleTextComponent from './Interfaces/FormflowComponents/ISampleTextComponent';
import ISampleVideoComponent from './Interfaces/FormflowComponents/ISampleVideoComponent';
import IScoreComponent from './Interfaces/FormflowComponents/IScoreComponent';
import ISelectAPIComponent from './Interfaces/FormflowComponents/ISelectAPIComponent';
import ITextComponent from './Interfaces/FormflowComponents/ITextComponent';
import ITreeViewComponent from './Interfaces/FormflowComponents/ITreeViewComponent';
import FormflowContext from './Util/FormflowContext';

export default class FormflowComponentsModal extends React.Component {


  renderComponent = (component: IBaseComponent | null) => {
    console.log("renderComponent ", component)
    if (component !== null) {
      switch (component.type) {

        case ComponentType.PHOTO: {
          const _photoComponent = component as IPhotoComponent;
          return (
            <PhotoTaskComponent
              {..._photoComponent}
              repeat={_photoComponent.repeat !== undefined ? _photoComponent.repeat : false}
            />
          )
        }

        case ComponentType.CONFIRM: {
          return (
            <ConfirmTaskComponent {...component as IConfirmComponent} />
          )
        }

        case ComponentType.DATE: {
          const _dateComponent = component as IDateComponent;
          return (
            <DateTaskComponent
              {..._dateComponent}
              required={_dateComponent.required !== undefined ? _dateComponent.required : false}
            />
          )
        }

        case ComponentType.TEXT: {
          const _textComponent = component as ITextComponent;
          return (
            <TextTaskComponent
              {..._textComponent}
              repeat={_textComponent.repeat !== undefined ? _textComponent.repeat : false}
            />
          )
        }

        case ComponentType.GOTO: {
          const _goToComponent = component as IGotoComponent;
          return (
            <GoToTaskComponent
              {..._goToComponent}
              repeat={_goToComponent.repeat !== undefined ? _goToComponent.repeat : false}
            />
          )
        }

        case ComponentType.MATRIX: {
          return (
            <MatrixTaskComponent {...component as IMatrixComponent} />
          )
        }
        case ComponentType.TREEVIEW: {
          return (
            <SelectTreeViewComponent {...component as ITreeViewComponent} />
          )
        }
        case ComponentType.SELECT:
        case ComponentType.SELECTAPI: {
          return (
            <SelectTaskComponent {...component as ISelectAPIComponent} />
          )
        }

        case ComponentType.EMPTY: {
          return (
            <FormflowContext.Consumer>
              {({ destroyComponentModalWindow }) => (
                <EmptyComponentStyle>
                  <div>
                    <p className='title-empty-style' >Escolha um componente de tarefa</p>
                    <Button className="button-cancel" type="primary" ghost onClick={destroyComponentModalWindow} >{('Cancelar').toUpperCase()}</Button>
                  </div>
                </EmptyComponentStyle>
              )}
            </FormflowContext.Consumer>
          )
        }


        case ComponentType.NUMBER: {
          return (
            <NumberTaskComponent {...component as INumberComponent} />
          )
        }
        case ComponentType.GPS: {
          return (
            <GPSTaskComponent {...component as IGPSComponent} />
          )
        }
        case ComponentType.MODEL: {
          return (
            <ModelTaskComponent {...component as IModelComponent} />
          )
        }
        case ComponentType.QRCODE: {
          return (
            <QRCodeTaskComponent {...component as IModelComponent} />
          )
        }

        case ComponentType.DRAW: {
            return(
              <DrawTaskComponent {...component as IDrawComponent} />
            );
        }

        case ComponentType.SCORE: {
            return(
              <ScoreTaskComponent {...component as IScoreComponent} />
            )
        }

        case ComponentType.SAMPLETEXT: {
          return (<SampleTextTaskComponent {...component as ISampleTextComponent} />
          )
        }
        case ComponentType.SAMPLEIMAGE: {
          return (<SampleImageTaskComponent {...component as ISampleImageComponent} />
            )
        }
        case ComponentType.SAMPLEVIDEO: {
          return (<SampleVideoTaskComponent {...component as ISampleVideoComponent} />
            )
        }
        case ComponentType.SAMPLE: {
          return (<SampleTaskComponent {...component as ISampleComponent} />
            )
        }
        case ComponentType.CALCULATOR: {
          return (<CalculatorTaskComponent {...component as ICalculatorComponent} />
            )
        }

        default: {
          return;
        }
      }
    }
    else { // in case of a new component
      return;
    }
  }

  render() {
    return (
      <FormflowContext.Consumer>
        {({ isComponentModalOpen, currentComponent, destroyComponentModalWindow }) => (
          <Wrapper>
            <Modal className="formflow-fullscreen"
              destroyOnClose={true}
              footer={false}
              visible={isComponentModalOpen}
              onCancel={destroyComponentModalWindow}
            >
              <Col lg={4} md={7} sm={10}>
                <div className="lateral-menu">
                  <FormflowLateralMenu />
                </div>
              </Col>
              <Col style={{ paddingLeft: '150px' }} lg={20} md={17} sm={14}>
                {this.renderComponent(currentComponent)}
              </Col>
            </Modal>
          </Wrapper>
        )}
      </FormflowContext.Consumer>
    );
  }
}

const Wrapper = styled.div`
    width: 100%;
    .lateral-menu{
        height: 100%; !important
    }
`
const EmptyComponentStyle = styled.div`
        padding-top: 50px;
        padding-left: 30px;
        .button-cancel{
            padding-left: unset;
        }
        .title-empty-style{
            font-weight: bold;
            color: ${Theme.secondary.midGrey};
            font-size: 16px;
        }
    
`



